import React, { useState } from "react";
import { useApp } from "../../contexts/AppContext";
import { callGemini } from "../../services/geminiService";
import AICaseGenerator from "../AI/AICaseGenerator";
import { useAuth } from "../../contexts/AuthContext";

const TopicCard = ({ topic }) => {
  const { markTopicAsRead } = useApp();
  const { profile } = useAuth();
  const [showAICase, setShowAICase] = useState(false);
  const [aiCase, setAiCase] = useState("");

  const isRead = Array.isArray(profile?.read_laws)
    ? profile.read_laws.includes(topic.id)
    : false;

  const handleGenerateCase = async () => {
    setShowAICase(true);
    setAiCase("");
    try {
      const caseText = await callGemini(
        `Genera un caso práctico corto (máximo 100 palabras) sobre "${topic.title}" en Panamá. Incluye un dilema ético o legal y pregunta qué debería hacer el corredor según la ley.`,
        "Eres un profesor de bienes raíces en Panamá."
      );
      setAiCase(caseText);
    } catch (error) {
      setAiCase("Error al generar el caso. Inténtalo de nuevo.");
    }
  };

  return (
    <div className="bg-white p-10 rounded-[3rem] card-shadow border border-slate-100 animate-fade">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
        <h3 className="text-2xl font-black">
          {topic.icon} {topic.title}
        </h3>
        <div className="flex gap-2">
          <button
            onClick={() => markTopicAsRead(topic.id)}
            // 💡 Eliminamos 'disabled' para permitir el unmark
            className={`px-4 py-2 rounded-xl text-xs font-bold transition-all border ${
              isRead
                ? "bg-emerald-500 text-white border-emerald-600 hover:bg-emerald-600 shadow-lg shadow-emerald-100"
                : "bg-slate-100 text-slate-600 border-slate-200 hover:bg-slate-200"
            }`}
          >
            {isRead ? "✓ Completado" : "Marcar como Leído"}
          </button>
        </div>
      </div>

      <div
        className="
    max-w-none mb-8
    /* Reset de la lista */
    [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:space-y-0
    
    /* Estilo de cada ítem (Ley) */
    [&_li]:text-slate-600 [&_li]:text-[15px] [&_li]:leading-relaxed
    [&_li]:py-4 [&_li]:border-b [&_li]:border-slate-100
    
    /* Quitar la línea al último ítem para que se vea pro */
    [&_li:last-child]:border-none
    
    /* Estilo para los números */
    [&_li]::marker:text-slate-400 [&_li]::marker:font-bold
  "
        dangerouslySetInnerHTML={{ __html: topic.content }}
      />

      {showAICase && (
        <AICaseGenerator
          caseText={aiCase}
          onClose={() => setShowAICase(false)}
        />
      )}
    </div>
  );
};

export default TopicCard;
